import { GetBannersParams } from '../__generated__/gateway/Api';
import { TAdMaterialTagsList, TBannersList } from '../interfaces/advertising';
import { IGlobalState } from '../reducers';

export const getBanners = (alias: string) => (state: IGlobalState): TBannersList => {
  return state.advertising.banners?.[alias ?? 'common'];
};
export const getLoadingBanners = (type: GetBannersParams['BannerTypes'][number]) => (state: IGlobalState): boolean =>
  state.advertising.loading?.[type];
export const getIsLoadedBanners = (state: IGlobalState): boolean => state.advertising.loaded;
export const getAdMaterialTags = (state: IGlobalState): TAdMaterialTagsList => state.advertising.adMaterialTags;
